import React from 'react';
import SecureAdminPage from './SecureAdminPage';

const SecureAdminRoute: React.FC = () => {
  // Since we're using a fixed route pattern, we can directly show the admin page
  // The route itself provides the security through the specific URL pattern

  // Show the admin panel directly since the route itself provides security
  return <SecureAdminPage />;
};

export default SecureAdminRoute;
